// src/screens/NotFound.jsx

import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/customer/page not found/NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();
  const chairRef = useRef(null);

  /* subtle wobble on mount */
  useEffect(() => {
    const el = chairRef.current;
    if (!el) return;
    el.classList.add("nf-chair--wobble");
    const t = setTimeout(() => el.classList.remove("nf-chair--wobble"), 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="nf-root">
      {/* decorative scattered pieces */}
      <span className="nf-dec nf-dec--1" aria-hidden>
        🪵
      </span>
      <span className="nf-dec nf-dec--2" aria-hidden>
        🔩
      </span>
      <span className="nf-dec nf-dec--3" aria-hidden>
        🪛
      </span>
      <span className="nf-dec nf-dec--4" aria-hidden>
        🪵
      </span>
      <span className="nf-dec nf-dec--5" aria-hidden>
        🔩
      </span>

      <div className="nf-card">
        {/* Big 404 text */}
        <div className="nf-number-wrap" aria-hidden>
          <span className="nf-num nf-num--4">4</span>

          {/* Broken chair illustration */}
          <div className="nf-chair-wrap" ref={chairRef}>
            <svg
              className="nf-chair-svg"
              viewBox="0 0 120 130"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden
            >
              {/* seat */}
              <rect
                x="15"
                y="52"
                width="90"
                height="14"
                rx="4"
                fill="#6B4C3B"
              />
              {/* back vertical */}
              <rect
                x="30"
                y="18"
                width="12"
                height="38"
                rx="4"
                fill="#8B6355"
              />
              <rect
                x="78"
                y="18"
                width="12"
                height="38"
                rx="4"
                fill="#8B6355"
              />
              {/* back horizontal bars */}
              <rect x="28" y="20" width="64" height="8" rx="3" fill="#A0796A" />
              <rect x="28" y="34" width="64" height="7" rx="3" fill="#A0796A" />
              {/* left legs — intact */}
              <rect
                x="20"
                y="66"
                width="10"
                height="46"
                rx="4"
                fill="#6B4C3B"
                transform="rotate(-5 20 66)"
              />
              {/* right legs — broken / fallen */}
              <rect
                x="88"
                y="64"
                width="10"
                height="30"
                rx="4"
                fill="#6B4C3B"
                transform="rotate(35 88 64)"
              />
              <rect
                x="96"
                y="80"
                width="10"
                height="28"
                rx="4"
                fill="#8B6355"
                transform="rotate(60 96 80)"
              />
              {/* cracks */}
              <path
                d="M55 52 L60 44 L65 52"
                stroke="#D67E43"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M70 52 L73 46 L77 52"
                stroke="#D67E43"
                strokeWidth="1.2"
                strokeLinecap="round"
              />
              {/* dust/debris */}
              <circle cx="30" cy="118" r="3" fill="#D67E43" opacity="0.5" />
              <circle cx="90" cy="114" r="2" fill="#6B4C3B" opacity="0.4" />
              <circle cx="60" cy="120" r="2.5" fill="#D67E43" opacity="0.35" />
              {/* shadow */}
              <ellipse
                cx="60"
                cy="122"
                rx="44"
                ry="5"
                fill="rgba(107,76,59,0.12)"
              />
            </svg>
          </div>

          <span className="nf-num nf-num--4 nf-num--last">4</span>
        </div>

        {/* Message */}
        <h1 className="nf-title">Page Not Found</h1>
        <p className="nf-desc">
          The page you're looking for doesn't exist or has been moved.
        </p>

        {/* Actions */}
        <div className="nf-actions">
          <button className="nf-btn-primary" onClick={() => navigate("/")}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
            Back to Home
          </button>

          <button className="nf-btn-secondary" onClick={() => navigate(-1)}>
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <polyline points="15 18 9 12 15 6" />
            </svg>
            Go Back
          </button>
        </div>

        {/* hint links */}
        <div className="nf-links">
          <span className="nf-links-label">Quick links:</span>
          <button
            className="nf-link"
            onClick={() => navigate("/customer/orders")}
          >
            My Orders
          </button>
          <span className="nf-sep">·</span>
          <button className="nf-link" onClick={() => navigate("/products")}>
            Shop
          </button>
          <span className="nf-sep">·</span>
          <button
            className="nf-link"
            onClick={() => navigate("/customer/help-support")}
          >
            Help
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
